module.exports = __webpack_public_path__ + "img/Eiszeit.6f7a4bee.svg";